export default __webpack_public_path__ + "static/media/Tapley's Pizza.57c4d630.jpeg";